import { OverlayPopupMenu, useSiteViewContext } from 'features/siteView'
import { EditFeatureMenu } from 'pages/siteView/siteMap/popupMenus/editMode/editFeature/EditFeatureMenu'
import React, { FC, useRef } from 'react'
import { GeckoSiteModel, GeckoUnit } from 'types'

import { SetCameraOrientation } from './editMode/editModel/SetCameraOrientation'

interface MapPopupMenusProps {
  siteModel: GeckoSiteModel
  allUnitsAtSite: ReadonlyArray<GeckoUnit>
}
export const MapPopupMenus: FC<MapPopupMenusProps> = (props) => {
  const { showEditSiteConfigPopupMenu, setShowEditSiteConfigPopupMenu } =
    useSiteViewContext()

  const editSiteConfigPopupRef = useRef<HTMLDivElement>(null)
  const addMarkupObjectsPopupRef = useRef<HTMLDivElement>(null)

  const popups = [editSiteConfigPopupRef, addMarkupObjectsPopupRef]

  return (
    <>
      {showEditSiteConfigPopupMenu && (
        <OverlayPopupMenu
          getDraggableGroup={() => popups}
          assignRef={editSiteConfigPopupRef}
          title={'Edit Site Config'}
          closeFunction={() => setShowEditSiteConfigPopupMenu(undefined)}
          startPosition={showEditSiteConfigPopupMenu}>
          <SetCameraOrientation />
        </OverlayPopupMenu>
      )}
      <EditFeatureMenu
        getDraggableGroup={() => popups}
        assignRef={addMarkupObjectsPopupRef}
        siteModel={props.siteModel}
        allUnitsAtSite={props.allUnitsAtSite}
      />
    </>
  )
}
